import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { download = false, config = {} }) {
    const balances = get(await this.$axios.get(routes.clientbalance.list(), config), 'data')

    if (!download) {
      commit(
        'AFTER_GET_ALL',
        {
          namespace: 'clientbalances',
          items: balances,
          params: config.params
        },
        { root: true }
      )
    }

    return balances
  }
}
